import styled from 'styled-components';

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(5, 10, 18, 0.78);
    backdrop-filter: blur(8px);
`;

export const Card = styled.div`
    position: relative;
    width: min(100%, 520px);
    max-height: min(90vh, 760px);
    overflow-y: auto;
    padding: 38px;
    border: 1px solid rgba(0, 255, 157, 0.24);
    border-radius: 22px;
    background: linear-gradient(145deg, #18212b, #101820 72%);
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5);
    color: #f4f7fa;

    h2 {
        margin: 4px 0 8px;
        color: #fff;
        font-size: clamp(24px, 5vw, 32px);
    }

    @media (max-width: 520px) {
        padding: 32px 22px 24px;
        border-radius: 18px;
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 14px;
    right: 16px;
    width: 34px;
    height: 34px;
    border: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    color: #d7e1e8;
    font-size: 24px;
    cursor: pointer;

    &:hover {
        background: rgba(255, 255, 255, 0.16);
    }
`;

export const Eyebrow = styled.span`
    color: #00ff9d;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
`;

export const Description = styled.p`
    margin: 0 0 24px;
    color: #aab8c5;
    font-size: 14px;
    line-height: 1.55;
`;

export const Fields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    label {
        display: flex;
        flex-direction: column;
        gap: 7px;
        color: #dce5eb;
        font-size: 13px;
        font-weight: 600;
    }

    input {
        width: 100%;
        min-height: 44px;
        padding: 0 12px;
        border: 1px solid #354453;
        border-radius: 9px;
        outline: none;
        background: #111922;
        color: #fff;
        font-size: 15px;
        transition: border-color 0.2s, box-shadow 0.2s;

        &:focus {
            border-color: #00d594;
            box-shadow: 0 0 0 3px rgba(0, 213, 148, 0.14);
        }
    }
`;

export const PasswordFields = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;

    label {
        display: flex;
        flex-direction: column;
        gap: 7px;
        color: #dce5eb;
        font-size: 13px;
        font-weight: 600;
    }

    input {
        width: 100%;
        min-height: 44px;
        padding: 0 12px;
        border: 1px solid #354453;
        border-radius: 9px;
        outline: none;
        background: #111922;
        color: #fff;
        font-size: 15px;

        &:focus {
            border-color: #00d594;
            box-shadow: 0 0 0 3px rgba(0, 213, 148, 0.14);
        }
    }

    @media (max-width: 460px) {
        grid-template-columns: 1fr;
    }
`;

export const Error = styled.p`
    margin: 16px 0 0;
    color: #ff9a9a;
    font-size: 13px;
`;

export const SubmitButton = styled.button`
    width: 100%;
    min-height: 46px;
    margin-top: 22px;
    border: 0;
    border-radius: 10px;
    background: linear-gradient(90deg, #00d594, #00ff9d);
    color: #07140f;
    font-size: 15px;
    font-weight: 800;
    cursor: pointer;
    transition: filter 0.2s, transform 0.2s;

    &:hover:not(:disabled) {
        filter: brightness(1.08);
        transform: translateY(-1px);
    }

    &:disabled {
        cursor: wait;
        opacity: 0.65;
    }
`;

export const Success = styled.div`
    padding-top: 12px;
    text-align: center;

    p {
        color: #b6c3cd;
        font-size: 14px;
        line-height: 1.6;
    }
`;

export const Icon = styled.div`
    display: grid;
    width: 58px;
    height: 58px;
    margin: 0 auto 18px;
    place-items: center;
    border-radius: 50%;
    background: rgba(0, 255, 157, 0.12);
    color: #00ff9d;
    font-size: 30px;
`;
